import { useContentContext } from '@context/content';

export const usePlanData = () => {
  const { plan, planContent, offer, offerContent } = useContentContext();

  return { plan, planContent, offer, offerContent };
};
